import { Messages, MessageValue } from 'app/modules/tp/_apiResponse';
import React from 'react';
import { Alert as RAlert } from "react-bootstrap";

export type CreateMessage = (heading: string, message: string, additionalMessage?: React.ReactNode) => React.ReactNode

export const createSuccessMessage = (heading: string, message: string | Messages, additionalMessage?: React.ReactNode) => (
    <Alert
        key={(new Date()).getTime()}
        variant="success"
        heading={heading}
        message={getFormattedMessage(typeof message === "string" ? message : message?.success)}
        show={true}
        children={additionalMessage}
    />
)

export const createWarningMessage = (heading: string, message: string | Messages, additionalMessage?: React.ReactNode) => (
    <Alert
        key={(new Date()).getTime()}
        variant="warning"
        heading={heading}
        message={getFormattedMessage(typeof message === "string" ? message : message?.warning)}
        show={true}
        children={additionalMessage}
    />
)

export const createErrorMessage = (heading: string, message: string | Messages, additionalMessage?: React.ReactNode) => (
    <Alert
        key={(new Date()).getTime()}
        variant="danger"
        heading={heading}
        message={getFormattedMessage(typeof message === "string" ? message : message?.error)}
        show={true}
        children={additionalMessage}
    />
)

export const createInfoMessage = (heading: string, message: string | Messages, additionalMessage?: React.ReactNode) => (
    <Alert
        key={(new Date()).getTime()}
        variant="info"
        heading={heading}
        message={getFormattedMessage(typeof message === "string" ? message : message?.info)}
        show={true}
        children={additionalMessage}
    />
)

type AlertProps = {
    variant: "success" | "danger" | "warning" | "info"
    heading: string,
    message: string | React.ReactElement,
    children?: React.ReactNode,
    show?: boolean,

    onClose?: () => void,
}

const Alert = ({ variant, heading, message, children, show = false, onClose }: AlertProps) => {
    const [isShow, setIsShow] = React.useState(show);

    const close = () => {
        setIsShow(false);
        onClose && onClose();
    }

    return (
        <RAlert
            variant={variant}
            show={isShow}
            onClose={close}
            dismissible
        >
            <div className="pt-3 ps-3 pe-3">
                <RAlert.Heading>{heading}</RAlert.Heading>
                <p>{message}</p>
                {
                    children &&
                    <>
                        <hr />
                        {children}
                    </>
                }
            </div>
        </RAlert>
    )
}

function getFormattedMessage(message?: string | MessageValue) {
    if (!message) {
        return "";
    }

    if (typeof message === "string") {
        return message;
    }
    if (typeof message === "object") {
        const messages: MessageValue = message;
        return <ul>
            {
                Object.keys(messages).map((key) => {
                    return <li key={key}>{messages[key]}</li>
                })
            }
        </ul>
    }

    return "";
}

export default Alert;
